<template>
  <vs-popup class="holamundo" title="Yeni Ürün Ekle" :active.sync="addNewProductActive" id="addProductPopup"
    v-esc="escape">
    <vs-row vs-type="flex" vs-w="12">
      <div class="w-full" @keyup.enter="addNewProduct">
        <vs-row vs-type="flex" vs-w="12">
          <v-select :disabled="excludedProductList.length == 0" id="product" name="Ürün" v-validate="'required'"
            v-model="toAddNewProduct" itemid="id" label="name" placeholder="Ürün Seçimi.."
            :options="excludedProductList" class="w-full" :clearable="false"></v-select>
          <span class="text-danger text-sm" v-show="errors.has('Ürün')">{{ errors.first('Ürün')}}</span>

          <vs-input-number min="0" color="primary" class="w-full" v-model="productIndex" v-if="toAddNewProduct"
            label="Kategori İçi Ürün Sıralaması" />
        </vs-row>
        <vs-row id="spacer" vs-type="flex" vs-w="12" class="mt-3" v-if="!toAddNewProduct" style="height:40vh;" />
        <vs-row vs-type="flex" vs-w="12" class="mt-3" v-if="toAddNewProduct">
        </vs-row>

        <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
          <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-x" @click="initValues">Vazgeç
          </vs-button>
          <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-plus" icon-after
            @click="addNewProduct">
            Ekle
          </vs-button>
        </vs-row>
      </div>
    </vs-row>

  </vs-popup>
</template>

<script>
  import {
    getExcludedProductsByCategory,
    addProductToCategory
  } from "@/api/ProductCategory";
  export default {
    data() {
      return {
        addNewProductActive: false,
        toAddNewProduct: {},
        excludedProductList: [],
        categoryId: null,
        productIndex: 0
      }
    },
    methods: {
      escape() {
        if (this.addNewProductActive == true) this.addNewProductActive = false;
      },
      addNewProduct: async function () {
        let checker = await this.$validator.validateAll();
        if (checker && Object.entries(this.toAddNewProduct).length != 0) {
          addProductToCategory(this.categoryId, this.toAddNewProduct.id,
              this.productIndex)
            .then(res => {
              if (res && res.status == 200) {
                this.$emit("saveChanges");
                this.initValues();
                this.$vs.notify({
                  color: 'success',
                  title: 'Başarılı !',
                  text: 'Ürün Başarıyla Kategoriye Eklendi !'
                });
              } else {
                this.$vs.notify({
                  color: 'danger',
                  title: 'Hata : ' + res.status,
                  text: 'Ürün Kategoriye Eklenemedi !'
                });
              }
            }).catch(err => {
              this.$vs.notify({
                color: 'danger',
                title: 'Hata !',
                text: 'Sunucuya Bağlantı Hatası !'
              });
            });
        }
      },
      initValues() {
        this.toAddNewProduct = {};
        this.excludedProductList = [];
        this.addNewProductActive = false;
      },
      getExcludedProductsByCategory(catId) {
        getExcludedProductsByCategory(catId).then(res => {
          if (res && res.status == 200) {
            this.excludedProductList = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Ürünler Listesi Yüklenemedi !'
            });
          }
        }).catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucuya Bağlantı Hatası !'
          });
        });
      },
    },
    watch: {
      addNewProductActive(val) {
        if (val) {
          this.getExcludedProductsByCategory(this.categoryId);
        }
      }
    }
  }

</script>

<style>
  #addProductPopup .vs__dropdown-menu {
    max-height: 35vh !important;
    overflow-x: hidden !important;
    overflow-y: scroll !important;
    position: static !important;
  }

</style>
